<template>
    <div>
        <div class="roma_menu">
            <el-select v-model="mode" placeholder="请选择" @change="changeMode" v-show="!isFirstPerson" :disabled="isRoaming">
                <el-option v-for="item in modeList" :key="item" :label="item" :value="item"></el-option>
            </el-select>
            <div class="input">
                <span>速度</span>
                <input type="number" max="2000" min="2" v-model="flySetting.speed" :disabled="isRoaming && !isPaused && !isFirstPerson" ref="speed" />
                <i>m/s</i>
            </div>
            <div class="input">
                <span>高度</span>
                <input type="number" max="20000" min="20" v-model="flySetting.height" :disabled="isRoaming && !isPaused && !isFirstPerson" ref="height" />
                <i>m</i>
            </div>
            <div class="btns" v-if="isRoaming && !isFirstPerson">
                <el-button @click.stop="endFly();" type="primary" round>停止</el-button>
                <el-button @click.stop="pauseFly();" v-if="!isPaused" round>暂停</el-button>
                <el-button @click.stop="resumeFly();" v-if="isPaused" round>恢复</el-button>
            </div>
            <div class="btns" v-if="isRoaming && isFirstPerson">
                <el-button @click.stop="exitFirstPerson()" type="primary" :disabled="isPending" round>退出</el-button>
            </div>
            <div class="btns" v-if="!isRoaming && !isFirstPerson">
                <el-button @click.stop="setRoma()" type="primary" :disabled="mode == '飞行漫游'" round>自由漫游</el-button>
                <el-button @click.stop="setPath()" type="primary" round>路径漫游</el-button>
                <el-button @click.stop="exit()" round>退出</el-button>
            </div>
        </div>

        <div class="path_list" v-show="showList">
            <div class="h"><span>路径漫游</span><i @click.stop="showList = false" class="iconfont iconguanbi"></i></div>
            <div class="b">
                <ul>
                    <li v-for="item in pathList" :key="item.id" :class="{ active: item.id == selected }">
                        <span>
                            <i @click.stop="selectPath(item)">{{item.name}}</i>
                        </span>
                        <span>
                            <i @click.stop="startFly(item)" class="iconfont iconbofang"></i>
                            <i @click.stop="deleteFly(item)" v-if="showEdit" class="iconfont iconshanchu"></i>
                        </span>
                    </li>
                    <li v-if="pathList.length == 0" class="empty">
                        <img  src="@/assets/img/none.png" />
                        <p>暂无路径</p>
                    </li>
                </ul>
                <el-button @click.stop="addFlyScheme" v-if="showEdit" type="primary" round>添加路径</el-button>
            </div>
        </div>

    </div>
</template>

<script>
import { debounce } from 'lodash-es';
import BusEvent from "@/busEvent";


var mapFlyEditor, firstPersonControls
var vehileMask = new Image()
    vehileMask.src = require('@/assets/img/car.png')
    vehileMask.className = 'vehile_mask'

export default {
    
    data(){
        return{
            mode: '人行漫游',
            modeList: ['人行漫游', '车行漫游', '飞行漫游'],
            flySetting: {
                height: 2,
                speed: 10
            },
            selected: '',
            showList: false,
            pathList: [],
            isRoaming: false,
            isPaused: false,
            isFirstPerson: false,
            isPending: false
        }
    },

    props: {
        flyData: {
            default: []
        },

        showEdit: {
            default: true
        }
    },

    computed: {

        viewer(){
            return window.viewer
        },

        container(){
            return window.viewer.container
        }
    },

    watch: {

        'flySetting.height': debounce(function( val ){
            val = parseInt( val )
            if( isNaN(Number(val)) ){
                this.flySetting.height = 1
                this.$message.warning( '漫游高度需要在 1 - 10000 之间' )
                return
            }
            if( val < 1 ){
                this.flySetting.height = 1
                this.$message.warning( '漫游高度需要在 1 - 10000 之间' )
                return
            }
            if( val > 10000 ){
                this.flySetting.height = 10000
                this.$message.warning( '漫游高度需要在 1 - 10000 之间' )
                return
            }
            if( this.isFirstPerson ){
                firstPersonControls.setHeight( val )
                firstPersonControls.moveForward( 1 )
            }else{
                mapFlyEditor.setHeight( Number( val ) )
            }
            this.$refs.height.blur()
        }, 500),

        'flySetting.speed': debounce(function( val ){
            val = parseInt( val )
            if( isNaN(Number(val)) ){
                this.flySetting.speed = 2
                this.$message.warning( '漫游速度需要在 2 - 2000 之间' )
                return
            }
            if( val < 2 ){
                this.flySetting.speed = 2
                this.$message.warning( '漫游速度需要在 2 - 2000 之间' )
                return
            }
            if( val > 2000 ){
                this.flySetting.speed = 2000
                this.$message.warning( '漫游速度需要在 2 - 2000 之间' )
                return
            }
            if( this.isFirstPerson ){
                firstPersonControls.moveSpeed  = val * 10
            }else{
                mapFlyEditor.setSpeed( Number( val ) )
            }
            this.$refs.speed.blur()
        }, 500)
    },

    mounted(){
        this.$bus.$emit( BusEvent.ToolDisabledChange, true )
        this.$bus.$emit( BusEvent.MenuDisbaledChange, true )
        this.init()
    },

    beforeDestroy(){
        mapFlyEditor.clear()
        if( firstPersonControls ){
            this.viewer.removeEventListener( 'update', this.updateFirstPersonControls )
            firstPersonControls.disconnect()
            firstPersonControls = null
            this.viewer.controls.enabled = true
        }
        this.$bus.$emit( BusEvent.ToolDisabledChange, false )
        this.$bus.$emit( BusEvent.MenuDisbaledChange, false )
    },

    methods: {

        init(){
            mapFlyEditor = new AMRT.MapFlyEditor( this.viewer )
            //完成绘制弹出设置窗口
            mapFlyEditor.onCompleteDraw = id => {
                this.$mr_confirm('是否闭合路径？', () => {
                    mapFlyEditor.closure()
                    complete.bind( this )()
                }, () => {
                    complete.bind( this )()
                })
                function complete(){
                    this.$prompt('请输入路径名称', '提示', {
                        confirmButtonText: '确定',
                        inputValue: `路径 ${this.pathList.length + 1}`,
                        inputPattern: /\S/,
                        inputErrorMessage: '路径名不能为空',
                        closeOnClickModal: false,
                        closeOnPressEscape: false,
                        closeOnHashChange: false
                    }).then(({ value }) => {
                        mapFlyEditor.data[ mapFlyEditor.data.length - 1 ].name = value
                        this.selected = mapFlyEditor.data[ mapFlyEditor.data.length - 1 ].id
                        this.updateList()
                    }).catch(( value ) => {
                        if( value === 'cancel' ){
                            mapFlyEditor.remove( mapFlyEditor.data[ mapFlyEditor.data.length - 1 ].id )
                            this.updateList()
                        }
                    })
                }
            }
            //飞行完成
            mapFlyEditor.onComplete = () => {
                console.log('onComplete');
                this.isRoaming = false
                this.isPaused = false
                setTimeout(() => {
                    this.$bus.$emit( BusEvent.CameraChange )
                }, 500)
            }
            //选中路线弹出预览窗口
            mapFlyEditor.onSelect = selected => {
                this.flySetting = {
                    height: selected.height,
                    speed: selected.speed
                }
                this.selected = selected.id
                this.updateList()
                this.showList = true
            }
            if( mapFlyEditor.data.length == 0 ) mapFlyEditor.setData( this.flyData )
            mapFlyEditor.load()

            this.changeMode('人行漫游')
        },

        updateList(){
            this.pathList = this.viewer.mapFlyEditor.saveToJSON()
        },

        changeMode( mode ){
            mapFlyEditor.reset()
            mapFlyEditor._changeSelectedMaterial()
            if( this.container.ondblclick ){
                mapFlyEditor.load()
            }
            this.container.ondblclick = null
            switch ( mode ) {
                case '人行漫游':
                    this.flySetting = {
                        speed: 2,
                        height: 2
                    }
                    this.selected = ''
                    this.showList = false
                    break;
                case '车行漫游':
                    this.flySetting = {
                        speed: 20,
                        height: 2
                    }
                    this.selected = ''
                    this.showList = false
                    break;
                case '飞行漫游':
                    this.flySetting = {
                        speed: 50,
                        height: 100
                    }
                    this.selected = ''
                    this.showList = false
                    break;
                default:
                    break;
            }
        },

        setRoma(){
            if( !this.flySetting.speed || !this.flySetting.height ){
                this.$message.warning('请设置漫游高度和速度')
                return
            }
            this.showList = false
            this.$notify({
                title: '提示',
                type: 'success',
                position: 'bottom-left',
                message: '鼠标左键双击任意位置开始第一视角自由漫游',
                duration: 3000
            })
            mapFlyEditor.clear()
            switch ( this.mode ) {
                case '人行漫游':
                    this.container.ondblclick = this.humanRoma.bind( this )
                    break;
                case '车行漫游':
                    this.container.ondblclick = this.vehicleRoma.bind( this )
                    break;
                default:
                    this.container.ondblclick = null
                    break;
            }
        },

        setPath(){
            if( this.container.ondblclick ){
                mapFlyEditor.load()
            }
            this.container.ondblclick = null
            this.updateList()
            this.showList = true
        },

        /**
         * 新增路线
         */
        addFlyScheme(){
            if( mapFlyEditor.isFlying ) return this.$message.warning('飞行中不允许此操作')
            mapFlyEditor.enable = true
            mapFlyEditor.reset()
            this.$notify({
                title: '提示',
                type: 'success',
                position: 'bottom-left',
                message: '鼠标左键单击地图绘制路径，右键单击结束绘制',
                duration: 3000
            })
        },

        selectPath( item ){
            this.selected = item.id
            mapFlyEditor.setSelected( item.id )
            this.flySetting.speed = mapFlyEditor.speed
            this.flySetting.height = mapFlyEditor.height
            this.viewer.controls.setView({
                destination: this.viewer.resetVector3ByHeight( mapFlyEditor.points[0], 5000 ),
                orientation: {
                    heading : 0.0,
                    pitch : -Cesium.Math.PI_OVER_TWO,
                    roll : 0.0
                }
            })
            setTimeout(() => {
                this.$bus.$emit( BusEvent.CameraChange )
            }, 100);
        },

        /**
         * 开始飞行
         */
        startFly( item ){
            if( mapFlyEditor.isFlying ) return this.$message.warning('飞行中不允许此操作')
            this.isRoaming = true
            this.isPaused = false
            this.selected = item
            mapFlyEditor.setSelected( item.id )
            mapFlyEditor.setHeight( Number( this.flySetting.height ) )
            mapFlyEditor.setSpeed( Number( this.flySetting.speed ) )
            mapFlyEditor.start( item.id )
            // this.flySetting.height = parseInt( item.height )
            // this.flySetting.speed = parseInt( item.speed )
            this.$bus.$emit( BusEvent.CameraChange )
            this.showList = false
        },

        /**
         * 结束飞行
         */
        endFly(){
            mapFlyEditor.end()
        },

        /**
         * 暂停飞行
         */
        pauseFly(){
            mapFlyEditor.pause()
            this.isPaused = true
        },

        /**
         * 恢复飞行
         */
        resumeFly(){
            // this.$refs.height.blur()
            // this.$refs.speed.blur()
            setTimeout(() => {
                mapFlyEditor.resume()
                this.isPaused = false
            }, 500)
        },

        /**
         * 删除飞行路径
         */
        deleteFly( item ){
            if( mapFlyEditor.isFlying ) return this.$message.warning('飞行中不允许此操作')
            mapFlyEditor.remove( item.id )
            mapFlyEditor.reset()
            this.selected = null
            this.updateList()
        },

        /**
         * 人行漫游
         */
        humanRoma( e ){
            this.container.ondblclick = null
            const v = this.viewer.pick( e )
            const destination = this.viewer.vector3ToCartesian( this.viewer.resetVector3ByHeight( v, this.flySetting.height ) ) 
            this.initFirstPersonRoam( destination )
        },

        /**
         * 车行漫游
         */
        vehicleRoma( e ){
            this.container.ondblclick = null
            const v = this.viewer.pick( e )
            const destination = this.viewer.vector3ToCartesian( this.viewer.resetVector3ByHeight( v, this.flySetting.height ) ) 
            this.initFirstPersonRoam( destination )
            this.container.appendChild( vehileMask )
            vehileMask.visible = true
        },

        initFirstPersonRoam( destination ){
            if( !firstPersonControls ){
                window.firstPersonControls = firstPersonControls = new AMRT.FirstPersonControls( this.viewer, this.viewer.camera, this.viewer.renderer.domElement )
                this.viewer.addEventListener( 'update', this.updateFirstPersonControls )
            }
            this.isPending = true
            firstPersonControls.enabled = true
            this.defaultView = this.viewer.controls.getView()
            this.viewer.map.camera.flyTo({
                destination,
                orientation: {
                    heading : Cesium.Math.toRadians(90.0),
                    pitch : Cesium.Math.toRadians(30.0),
                    roll : 0.0
                },
                complete: () => {
                    this.isPending = false
                    firstPersonControls.setHeight( this.flySetting.height )
                    firstPersonControls.moveSpeed  = this.flySetting.speed * 10
                    setTimeout(() => {
                        viewer.controls.enabled = false
                        //解决设置完视角后不渲染的bug
                        let p1 = viewer.cartesian3ToVector3( viewer.map.camera.position.clone() )
                        let dir = viewer.vector3ToCartesian( p1.sub( viewer.resetVector3ByHeight( p1, 0.1 ) ))
                        viewer.map.camera.look(dir, 0.5)
                    }, 100)
                }
            })
            this.isRoaming = true
            this.isFirstPerson = true
            mapFlyEditor.clear()
            
            this.$notify({
                title: '提示',
                type: 'success',
                position: 'bottom-left',
                message: '请使用 WSAD 进行自由行走',
                duration: 3000
            })
        },

        updateFirstPersonControls(){
            firstPersonControls.update()
        },

        exitFirstPerson(){
            this.isRoaming = false
            this.isFirstPerson = false
            firstPersonControls.enabled = false
            if( vehileMask.visible ){
                this.container.removeChild( vehileMask )
                vehileMask.visible = false
            }
            this.viewer.controls.enabled = true
            this.viewer.controls.setView( this.defaultView )
            this.defaultView = null
            setTimeout(() => {
                this.$bus.$emit( BusEvent.CameraChange )
            }, 500)
            mapFlyEditor.load()
        },

        exit(){
            mapFlyEditor.reset()
            mapFlyEditor.enable = false
            this.$emit('exit')
        }
    }
}
</script>

<style lang="scss" scoped>
.roma_menu{
    width: 800px; height: 64px; padding: 0 10px; position: fixed; bottom: 80px; left: 450px; display: flex; align-items: center; z-index: 2; background-color: #F2F4F6; justify-content: space-around; border-radius: 5px;
    /deep/ .el-select{ width: 140px; }
    .input{
        display: flex;height: 100%; align-items: center; position: relative;
        span{margin-right: 5px;}
        input{ width: 70px; padding: 0 20px 0 10px; background-color: #fff; height: 34px; color: #182C49; border-radius: 2px; font-size: 14px; }
        input:disabled{ background-color: #eee; color: #999; border-color: #999; cursor: no-drop; }
        i{display: block;position: absolute; right: 10px;color: #182C49;font-size: 14px;}
    }
    .btns{
        display: flex;
        /deep/ .el-button{height: 34px;line-height: 10px; border-color: #1458EA;}
        /deep/ .el-button--primary{background-color: #1458EA;}
        /deep/ .is-disabled{background-color: #C0C4CC; color: #FFF; border-color: #C0C4CC;}
    }
}
.path_list{
    width: 260px; position: fixed; right: 440px; z-index: 1; bottom: 200px;
    .h{ 
        height: 34px; width: calc(100% - 20px); padding: 0 10px; border-radius: 5px 5px 0 0; color: #FFF; display: flex; justify-content: space-between; align-items: center; background-color: #1458EA; font-size: 14px;
        .iconfont{cursor: pointer; font-size: 14px;}
    }
    .b{
        width: 100%; height: 340px; background-color: #F2F4F6; border-radius: 0 0 5px 5px; display: flex; flex-direction: column; align-items: center;
        /deep/ .el-button{height: 34px;line-height: 10px; border-color: #1458EA; position: absolute; bottom: 20px;}
        /deep/ .el-button--primary{background-color: #1458EA;}
        ul{
            width: 100%;
            li{ 
                width: calc(100% - 20px); display: flex; justify-content: space-between; height: 34px; align-items: center;  font-size: 14px; padding: 0 10px;
                i{ font-style: normal; color: #182C49; cursor: pointer; }
                span{
                    i{margin: 0 5px; }
                }
            }
            .empty{ display: flex; justify-content: center; flex-direction: column; align-items: center; margin-top: 100px; opacity: 0.5; img{  width: 92px; } p{text-align: center; margin-top: 10px;font-size: 14px;} }
            .active{ background-color: #D9E4F7; }
        }
    }
}
</style>
<style>
.vehile_mask{position: absolute; left: 0; top: 0; z-index: 1; width: 100%; height: 100%; pointer-events: none;}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"]{
  -moz-appearance: textfield;
}
</style>